import React from "react";
import DisneyoriginalApi from "./DisneyoriginalApi";
import Recomend from "./Recomend";

const Disneyoriginal = ()=>{
    return(
        <Recomend Apidata ={DisneyoriginalApi}  Head="Disney+Originals"/>
    )
}
export default Disneyoriginal;